import React, { useEffect, useState } from "react";
import { Mic, MicOff } from "lucide-react";
import { mmss } from "./thLive";

// §12.6 — fixed pill, bottom-right, left of the Ask button, on every other app tab during a live call.
export function AwayBar({ live, onReturn }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  return (
    <div className="fixed z-[70] flex items-center gap-3 rounded-full pl-4 pr-1.5 py-1.5 text-white text-[12.5px]" style={{ right: 88, bottom: 20, background: "#16161A", boxShadow: "0 10px 30px rgba(0,0,0,.25)" }} data-testid="th-awaybar">
      <span className="th-dot sm pulse" style={{ background: "#E5484D", width: 8, height: 8, borderRadius: 999, display: "inline-block" }} />
      <span className="font-semibold">{live.name}</span>
      <span className="tabular-nums" style={{ color: "#A1A1A6" }}>{mmss(now - live.startedAt)}</span>
      <span style={{ color: "#A1A1A6" }} aria-label={live.muted ? "Muted" : "Mic on"}>{live.muted ? <MicOff size={14} /> : <Mic size={14} />}</span>
      <button type="button" onClick={onReturn} className="h-8 px-3.5 rounded-full font-semibold text-[12.5px]" style={{ background: "#fff", color: "#141412" }} data-testid="th-awaybar-return">Return to call</button>
    </div>
  );
}
